import {
  TQueryActiveUsers,
  TQueryActiveUsersSnapshot,
  TQueryPostEngagementTop,
  TQueryPostEngagementViewsSeries,
} from '@src/modules/analytics'

import { request } from './config'

export const getAnalyticsOverview = (token: string) => request({ url: 'analytics/overview', method: 'GET' }, { token })

export const getActiveUsers = (params: TQueryActiveUsers, token: string) =>
  request(
    {
      url: 'analytics/active-users',
      method: 'GET',
      params: { period: params.period || 'daily', from: params.from, to: params.to },
    },
    { token },
  )

export const getActiveUsersSnapshot = (params: TQueryActiveUsersSnapshot, token: string) =>
  request(
    {
      url: 'analytics/active-users/snapshot',
      method: 'GET',
      params,
    },
    { token },
  )

export const getPostEngagementOverview = (token: string) =>
  request({ url: 'analytics/post-engagement/overview', method: 'GET' }, { token })

export const getPostEngagementTopPosts = (params: TQueryPostEngagementTop, token: string) =>
  request(
    {
      url: 'analytics/post-engagement/top-posts',
      method: 'GET',
      params: { limit: params.limit ?? 10, sortBy: params.sortBy ?? 'views' },
    },
    { token },
  )

export const getPostEngagementViewsSeries = (params: TQueryPostEngagementViewsSeries, token: string) =>
  request(
    {
      url: 'analytics/post-engagement/views-series',
      method: 'GET',
      params: { from: params.from, to: params.to },
    },
    { token },
  )
